import React, { useState } from 'react';
import { createArray } from '../_utils';
var SidemenuSkeleton = function (props) {
    var _a = props.position, position = _a === void 0 ? 'relative' : _a;
    var _b = useState(false), hiddenValue = _b[0], setHiddenValue = _b[1];
    return (React.createElement("div", { style: { position: position } },
        React.createElement("div", { className: "col-md-2 d-none d-md-block bg-dark sidebar" + (hiddenValue ? ' small' : ''), style: { position: 'absolute' } },
            React.createElement("div", { className: "sidebar-sticky custom" },
                React.createElement("ul", { className: "nav flex-column" },
                    React.createElement("li", { className: "nav-item toggle-size-button-container" },
                        React.createElement("section", { className: "toggle-size-button", onClick: function () { return setHiddenValue(!hiddenValue); } },
                            React.createElement("i", { className: "sidebar-nav-item-icon fal fa-chevron-double-left" }))),
                    createArray(6).map(function (i) { return (React.createElement("span", { className: "mx-3 skeleton-line skeleton-h-xl", key: i })); })))),
        React.createElement("div", { id: "sidebar-text", className: "col-md-9 ml-sm-auto col-lg-10 pt-3 px-4", style: {
                position: 'relative',
                overflow: 'hidden',
                minHeight: 500
            } })));
};
export default React.memo(SidemenuSkeleton);
